export class ObjectCollection {
    constructor() {
        this.#map = new Map();
    }
    // Метод для добавления объекта
    add(...args) {
        args.forEach(object => {
            if (object && 'id' in object) {
                this.#map.set(object.id, object); // Добавляем объект по ключу id
            }
            else {
                console.error("Объект должен содержать id.");
            }
        });
    }
    clear() {
        this.#map.clear();
    }
    // Метод для получения объекта по id
    get(id) {
        return this.#map.get(id); // Получаем объект по ключу id
    }
    // Метод для получения всех объектов
    getAll() {
        return Array.from(this.#map.values());
    }
    // Метод для проверки наличия объекта по id
    has(id) {
        return this.#map.has(id);
    }
    get isEmpty() {
        return !!this.getAll().length;
    }
    // Метод для удаления объекта по id
    remove(id) {
        if (this.#map.has(id)) {
            this.#map.delete(id); // Удаляем объект по ключу id
        }
        else {
            console.log(`Объект с id ${id} не найден.`);
        }
    }
    #map;
}
